import { nonSeeded } from "../fable_modules/fable-library.3.7.14/Random.js";
import { map, concat, sortBy, toList } from "../fable_modules/fable-library.3.7.14/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library.3.7.14/Range.js";
import { comparePrimitives } from "../fable_modules/fable-library.3.7.14/Util.js";
import { empty } from "../fable_modules/fable-library.3.7.14/List.js";
import { PixelDissolver, PixelDissolverState } from "../Model.fs.js";

const random = (() => {
    const objectArg = nonSeeded();
    return (arg00) => objectArg.Next1(arg00);
})();

export function create(width, height, zoom) {
    const dissolveWidth = (width / zoom) - zoom;
    return new PixelDissolver(toList(sortBy((_arg1) => random(width * height), concat(map((y) => map((x) => [x, y], rangeDouble(0, 1, (~(~dissolveWidth)) + 1)), rangeDouble(0, 1, (~(~((height / zoom) - zoom))) + 1))), {
        Compare: comparePrimitives,
    })), empty(), zoom, 750, new PixelDissolverState(0));
}

